export function DocumentsTypeFilter({ documentsCount, pdfCount, webCount, typeFilter, setTypeFilter }) {
  return (
    <select
      data-testid="documents-type-filter"
      value={typeFilter}
      onChange={(event) => setTypeFilter(event.target.value)}
      className="h-9 cursor-pointer rounded-sm border border-zinc-800 bg-zinc-900/50 px-3 text-sm text-white focus:border-white focus:outline-none focus:ring-0"
    >
      <option value="all">Tous les types ({documentsCount})</option>
      <option value="pdf">PDF ({pdfCount})</option>
      <option value="web">Web ({webCount})</option>
    </select>
  );
}
